import { render, staticRenderFns } from "./poll-review.vue?vue&type=template&id=6ac4d442&scoped=true"
import script from "./poll-review.vue?vue&type=script&lang=js"
export * from "./poll-review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac4d442",
  null
  
)

export default component.exports